module.exports = "/_next/static/images/d5fc001c2bc4d27006e13baaf0213635-thumb_video.jpg.webp";